import {FC, useCallback, useMemo, useRef} from "react";
import {PrimaryButton} from "@fluentui/react";

interface IPathElementPickerProps {
    title?: string;
    disabled?: boolean;
    path?: string;
    pathPicked: (path: string) => void;
}

export const PathElementPicker: FC<IPathElementPickerProps> = ({
                                                                   title,
                                                                   disabled,
                                                                   path,
                                                                   pathPicked,
                                                               }) => {
    const inputRef = useRef<HTMLInputElement>(null);
    // const [electron, setElectron] = useState<any>(null);
    // const [dialog, setDialog] = useState<any>(null);

    // useEffect(() => {
    //     if (isElectron({ alert: true })) {
    //         setElectron(window.require('electron'));
    //     }
    // }, []);

    // useEffect(() => {
    //     if (electron) {
    //         console.log(electron);
    //         setDialog(electron.dialog);
    //     }
    // }, [electron]);

    // const handleClick = useCallback(async () => {
    //     const result = await dialog.showOpenDialog({
    //         properties: ['openDirectory']
    //     });

    //     if (!result.canceled) {
    //         pathPicked(result.filePaths[0]);
    //     }
    // }, [dialog, pathPicked]);

    const handleClick = useCallback(() => {
        inputRef.current?.click();
    }, [pathPicked, inputRef]);

    const onFileInputChanged = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            if (e.target.files && e.target.files.length > 0) {
                const firstFile = e.target.files[0];
                const path = (firstFile as any).path as string;
                const countOfSlashes = path.split("\\").length;
                const countOfBackSlashes = path.split("/").length;
                const folderOnly =
                    countOfSlashes > countOfBackSlashes
                        ? path.split("\\").slice(0, -1).join("\\")
                        : path.split("/").slice(0, -1).join("/");
                pathPicked(folderOnly);
            }
        },
        [pathPicked],
    );

    const endTitle = useMemo<{ fullPath: string; ellipsisPath: string }>(() => {
        const ret: { fullPath: string; ellipsisPath: string } = {
            fullPath: "",
            ellipsisPath: "",
        };
        if (title) {
            ret.fullPath = ret.ellipsisPath = title;
        }
        if (path) {
            let ellipsisPath = path;
            if (path.length > 30) {
                ellipsisPath = "..." + path.substring(path.length - 30);
            }
            if (title) {
                ret.fullPath += ": ";
                ret.ellipsisPath += ": ";
            }

            ret.ellipsisPath += ellipsisPath;
            ret.fullPath += path;
        }
        return ret;
    }, [title, path]);

    return (
        <>
            <input hidden ref={inputRef} type="file" onChange={onFileInputChanged}/>
            <PrimaryButton title={endTitle.fullPath} onClick={handleClick}>
                {endTitle.ellipsisPath}
            </PrimaryButton>
        </>
    );
};
